import { useState } from "react";

const useScratchPad = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState("");

  return {
    isOpen,
    setIsOpen,
    content,
    setContent,
  };
};

export default useScratchPad;
